<script>
  /**
   * 横田工業 日報 ビュー
   *  - 日報の表示/編集
   */
  import { YOKOTA_LOG_SCHEME } from '../../scheme'

  export let data
  export let isEditable

  $: length = data?.logs?.length || 0
</script>

<div class="table-container">
  <table
    class="table is-bordered is-striped"
    style="width: max-content; table-layout: fixed;"
  >
    <tbody>
      {#each YOKOTA_LOG_SCHEME as field, row}
        {@const { name, type } = field}
        {#if type}
          <tr>
            <!-- ヘッダ ラベル -->
            <td class="header">{field.label}</td>
            <!-- 列フィールド 入力欄 -->
            {#each { length } as _, column}
              <!-- チェックボックス -->
              {#if type === 'checkbox'}
                <td>
                  <input
                    type="checkbox"
                    disabled={!isEditable}
                    data-testid={`${name}${column}`}
                    bind:checked={data.logs[column][name]}
                  />
                </td>
              {:else}
                <!-- テキスト入力 -->
                {#if isEditable}
                  <td
                    contenteditable="true"
                    data-testid={`${name}${column}`}
                    bind:textContent={data.logs[column][name]}
                  />
                {:else}
                  <td data-testid={`${name}${column}`}
                    >{data.logs[column][name]}</td
                  >
                {/if}
              {/if}
            {/each}

            <!-- 最終列に処理を入れるためのスロット -->
            <slot name="last-column" {row} />
          </tr>
        {/if}
      {/each}

      <!-- 作業者と時間 -->
      {#each data.memberList as member, row}
        <tr>
          <!-- 名前 -->
          <td
            style={`font-size:${member.length > 5 ? 'xx-small' : 'medium'}`}
            data-testid={`memberName${row}`}>{member}</td
          >
          <!-- 時間 -->
          {#each { length } as _, column}
            {#if isEditable}
              <td
                contenteditable="true"
                data-testid={`hourCell${row}-${column}`}
                bind:textContent={data.logs[column].hours[member]}
              />
            {:else}
              <td data-testid={`hourCell${row}-${column}`}
                >{data.logs[column].hours[member]}</td
              >
            {/if}
          {/each}
        </tr>
      {/each}

      <!-- 最終行に処理を入れるためのスロット -->
      <slot name="last-row" />
    </tbody>
  </table>
</div>

<style>
  .header {
    width: 100px;
    font-weight: bold;
  }

  td {
    width: 80px;
  }

  input[type='checkbox'] {
    zoom: 150%;
    margin: 0;
  }
</style>
